import { render } from "./hostChannel.vue?vue&type=template&id=6646f9be&scoped=true"
import script from "./hostChannel.vue?vue&type=script&lang=js"
export * from "./hostChannel.vue?vue&type=script&lang=js"

import "./hostChannel.vue?vue&type=style&index=0&id=6646f9be&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6646f9be"],['__file',"src/views/data/components/daliyReport/hostChannel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6646f9be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6646f9be', __exports__)) {
    console.log('reload')
    api.reload('6646f9be', __exports__)
  }
  
  module.hot.accept("./hostChannel.vue?vue&type=template&id=6646f9be&scoped=true", () => {
    console.log('re-render')
    api.rerender('6646f9be', render)
  })

}


export default __exports__